import { PANEL_BORDERS } from "@frontend/components/atoms/Panel/constants";

export const CARD_TAG_NAME = "card" as const;

export const CARD_GLOWS = [
  "border",
  "background",
  "spotlight",
  "rainbow",
  "glow-line",
  "pulse",
] as const;

export const CARD_DEFAULT_GLOW = "border" as const;

export const CARD_BORDERS = PANEL_BORDERS;

export const CARD_DEFAULT_BORDER = "solid" as const;

export const CARD_DEFAULT_SIZE = 200;

export const CARD_DEFAULT_BLUR = 40;

export const CARD_DEFAULT_BORDER_WIDTH = 1;

export const CARD_DEFAULT_INTENSITY = 1;

// Opacity falloff inside a CardGroup
export const CARD_GROUP_MAX_DISTANCE = 1.5;

// The card's own frame border in "solid" mode
export const CARD_FRAME_BORDER_WIDTH_PX = 1;

// Two-layer mask
export const CARD_BORDER_RING_MASK =
  "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)";
